module.exports = __webpack_public_path__ + "static/alan-bk-418dd221234ee62b037d5675ab984448.jpg";